import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    about: [
      { name: 'Leadership', href: 'https://entrepreneurladyhustler.com/en/leadership/' },
      { name: 'Our Mission', href: 'https://entrepreneurladyhustler.com/en/about/' },
      { name: 'Impact', href: 'https://entrepreneurladyhustler.com/en/impact/' },
    ],
    programs: [
      { name: 'Membership', href: 'https://join.entrepreneurladyhustler.com' },
      { name: 'Closing the Gap', href: 'https://entrepreneurladyhustler.com/en/closing-the-gap-womens-humanitarian-campaign/' },
      { name: 'The Société', href: 'https://societe.entrepreneurladyhustler.com' },
    ],
    getInvolved: [
      { name: 'Become a Member', href: 'https://join.entrepreneurladyhustler.com' },
      { name: 'Speak With Us', href: 'https://entrepreneurladyhustler.com/en/for-speakers-panelists-and-thought-leaders/' },
      { name: 'Partner', href: 'https://entrepreneurladyhustler.com/en/institutional-partnership-inquiry/' },
    ],
    connect: [
      { name: 'Contact', href: 'mailto:hello@entrepreneurladyhustler.com' },
      { name: 'The Journal', href: 'https://blog.entrepreneurladyhustler.com/en/blog' },
    ],
  };

  const socialLinks = [
    { name: 'Instagram', url: 'https://instagram.com/ladyhustlerclub', icon: 'instagram' },
    { name: 'LinkedIn', url: 'https://linkedin.com/company/ladyhustlerclub', icon: 'linkedin' },
    { name: 'Facebook', url: 'https://facebook.com/ladyhustlerclub', icon: 'facebook' },
  ];

  return (
    <footer className="bg-[#767C91] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <a href="https://entrepreneurladyhustler.com/en/" className="inline-block mb-4">
              <span className="font-cormorant text-2xl font-semibold text-white">
                LHSC
              </span>
            </a>
            <p className="font-lato-light text-sm text-[#CFD7DE] leading-relaxed mb-6">
              The Lady Hustler Society Club is a federally registered Canadian nonprofit advancing women's economic empowerment worldwide.
            </p>
            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  className="text-[#CFD7DE] hover:text-white transition-colors duration-200"
                  aria-label={social.name}
                >
                  <span className="sr-only">{social.name}</span>
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    {social.icon === 'instagram' && (
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    )}
                    {social.icon === 'linkedin' && (
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                    )}
                    {social.icon === 'facebook' && (
                      <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
                    )}
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* About Links */}
          <div>
            <h4 className="font-josefin text-xs uppercase tracking-widest text-white mb-4">About</h4>
            <ul className="space-y-3">
              {footerLinks.about.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-[#CFD7DE] hover:text-white transition-colors duration-200 text-sm font-lato-light"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Programs Links */}
          <div>
            <h4 className="font-josefin text-xs uppercase tracking-widest text-white mb-4">Programs</h4>
            <ul className="space-y-3">
              {footerLinks.programs.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-[#CFD7DE] hover:text-white transition-colors duration-200 text-sm font-lato-light"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Get Involved Links */}
          <div>
            <h4 className="font-josefin text-xs uppercase tracking-widest text-white mb-4">Get Involved</h4>
            <ul className="space-y-3">
              {footerLinks.getInvolved.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-[#CFD7DE] hover:text-white transition-colors duration-200 text-sm font-lato-light"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect Links */}
          <div>
            <h4 className="font-josefin text-xs uppercase tracking-widest text-white mb-4">Connect</h4>
            <ul className="space-y-3">
              {footerLinks.connect.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-[#CFD7DE] hover:text-white transition-colors duration-200 text-sm font-lato-light"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <a 
                href="mailto:hello@entrepreneurladyhustler.com"
                className="text-[#CFD7DE] hover:text-white transition-colors duration-200 text-sm font-lato-light"
              >
                hello@entrepreneurladyhustler.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#CFD7DE]/30 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="font-lato-light text-sm text-[#CFD7DE]">
            © {currentYear} The Lady Hustler Society Club. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="https://entrepreneurladyhustler.com/en/privacy/" className="text-[#CFD7DE] hover:text-white text-sm font-lato-light transition-colors duration-200">
              Privacy Policy
            </a>
            <a href="https://entrepreneurladyhustler.com/en/terms/" className="text-[#CFD7DE] hover:text-white text-sm font-lato-light transition-colors duration-200">
              Terms of Use
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
